module.exports = __webpack_public_path__ + "static/media/dagger.cb2c7c8e.svg";